import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface PipelineDetailFilters {
  stage?: string | null;
  consultantId?: string | null;
  sdrId?: string | null;
  source?: string | null;
  channel?: string | null;
  createdFrom?: Date | null;
  createdTo?: Date | null;
  businessUnit?: string | null;
  limit?: number;
}

export interface PipelineDealDetail {
  id: string;
  name: string;
  stage: string;
  total_amount: number;
  created_at: string;
  closed_date: string | null;
  deals_source: string | null;
  deals_channel: string | null;
  business_unit: string | null;
  contact_name: string | null;
  consultant_name: string | null;
  sdr_name: string | null;
  days_in_pipeline: number;
}

export function usePipelineDealsDetail(filters: PipelineDetailFilters = {}, enabled = true) {
  return useQuery({
    queryKey: [
      'pipeline-deals-detail',
      filters.stage,
      filters.consultantId,
      filters.sdrId,
      filters.source,
      filters.channel,
      filters.createdFrom?.toISOString(),
      filters.createdTo?.toISOString(),
      filters.businessUnit,
      filters.limit,
    ],
    queryFn: async () => {
      console.log('📋 [PipelineDealsDetail RPC] Fetching with filters:', filters);
      
      const { data, error } = await supabase.rpc('get_pipeline_deals_detail', {
        p_stage: filters.stage || null,
        p_consultant_id: filters.consultantId || null,
        p_sdr_id: filters.sdrId || null,
        p_source: filters.source || null,
        p_channel: filters.channel || null,
        p_created_from: filters.createdFrom?.toISOString() || null,
        p_created_to: filters.createdTo?.toISOString() || null,
        p_business_unit: filters.businessUnit || null,
        p_limit: filters.limit || 100,
      });

      if (error) {
        console.error('❌ [PipelineDealsDetail RPC] Error:', error);
        throw error;
      }

      const deals = data as unknown as PipelineDealDetail[];

      console.log('✅ [PipelineDealsDetail RPC] Success:', {
        dealsCount: deals?.length,
      });

      return deals;
    },
    enabled,
    staleTime: 2 * 60 * 1000, // 2 minutes cache
    refetchOnWindowFocus: false,
  });
}
